import { createReducer, on } from '@ngrx/store'
import { IStorageState } from '@adex/shared/models/states/storage.state'
import { patchState, StorageStateCreator } from '@adex/store/utils'
import { deleteStorageValue, initStorageState, setStorageStateValue, unauthorizedUser } from '../actions/global.actions'


const initialState: IStorageState = StorageStateCreator.create()

export const storageReducer = createReducer(
  initialState,
  on(unauthorizedUser, state => ({ ...initialState, personalization: state.personalization })),
  on(initStorageState, (_, { state }) => ({ ...state })),
  on(setStorageStateValue, (state, { key, value }) => patchState(state, key, value)),
  on(deleteStorageValue, (state, { key }) => ({ ...state, [key]: null }))
)
